<template>
  <ValidationObserver ref="observer">
    <form class="account-form mt-8" @submit.prevent="submit">
      <div class="d-flex flex-column flex-md-row">
        <div class="flex-1 mr-md-2">
          <div class="text-5">First name</div>
          <ValidationProvider
            v-slot="{ errors }"
            name="First name"
            rules="required"
          >
            <v-text-field
              id="firstName"
              v-model="firstName"
              placeholder="Enter your first name"
              outlined
              class="c-input mt-2"
              :error-messages="errors"
              @input="formDirty = true"
            ></v-text-field>
          </ValidationProvider>
        </div>
        <div class="flex-1 ml-md-2">
          <div class="text-5">Last name</div>
          <ValidationProvider
            v-slot="{ errors }"
            name="Last name"
            rules="required"
          >
            <v-text-field
              v-model="lastName"
              placeholder="Enter your last name"
              :error-messages="errors"
              @input="formDirty = true"
              outlined
              class="c-input mt-2"
            ></v-text-field>
          </ValidationProvider>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-1 mr-2">
          <div class="text-5">Email address</div>
          <v-text-field
            v-model="email"
            required
            readonly
            disabled
            outlined
            class="c-input mt-2"
          ></v-text-field>
        </div>
        <div class="flex-1 ml-2 d-none d-md-block"></div>
      </div>
      <v-checkbox
        v-model="subscribed"
        label="I’d like to be notified of Product updates, Marketing promotions, and News via email."
        class="mt-0 text-5 emails-subscribed"
        @change="formDirty = true"
      ></v-checkbox>
      <div class="d-flex justify-end">
        <input type="submit" class="d-none" />
        <c-btn
          :disabled="!formDirty"
          :loading="updateInfo.isSubmitting"
          @click="submit"
          >Update Details</c-btn
        >
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";
import { required } from "vee-validate/dist/rules";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} can not be empty.",
});
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    firstName: "",
    lastName: "",
    email: "",
    subscribed: true,
    formDirty: false,
  }),
  computed: {
    ...mapGetters({
      updateInfo: "userInfo/updateInfo",
      userInfo: "userInfo/basicInfo",
    }),
  },
  methods: {
    async submit() {
      const isFormValid = await this.$refs.observer.validate();
      if (isFormValid) {
        await this.$store.dispatch("userInfo/updateInfo", {
          firstName: this.firstName,
          lastName: this.lastName,
          subscribed: this.subscribed,
        });
        if (!this.updateInfo.error) {
          this.$store.dispatch("addAlert", {
            type: "success",
            title: "Success",
            message: "Account updated",
          });
          this.formDirty = false;
        } else {
          this.$store.dispatch("addAlert", {
            message: this.updateInfo.error.message,
            title: "Error",
            type: "error",
          });
        }
      }
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(data) {
        this.firstName = data?.firstName;
        this.lastName = data?.lastName;
        this.email = data?.email;
        this.subscribed = data?.subscribeMailingList;
      },
    },
  },
};
</script>

<style lang="scss">
.account-form {
  .v-input--selection-controls {
    .v-input__slot {
      label {
        font-size: 14px !important;
        color: var(--black) !important;
      }
    }
  }
}
</style>
